<div class="people-section">
  <div class="people-section__header">
    <h1>People</h1>
    <div class="ch-tabs">
      <div
        class="internal"
        (click)="showUsers = true"
        [ngClass]="{ active: showUsers }"
      >
        CLIENT USERS
      </div>
      <div
        (click)="showUsers = false"
        class="internal"
        [ngClass]="{ active: !showUsers }"
      >
        STAFF
      </div>
    </div>
  </div>
  @if (showUsers) {
    <div
      class="btn-group d-inline-block"
      dropdown
      [autoClose]="true"
      placement="bottom right"
    >
      <button
        id="button-basic"
        dropdownToggle
        type="button"
        class="btn btn-primary dropdown-toggle"
        aria-controls="dropdown-basic"
      >
        Add Client User <span class="caret"></span>
      </button>
      <ul
        id="dropdown-basic"
        *dropdownMenu
        class="dropdown-menu"
        role="menu"
        aria-labelledby="button-basic"
      >
        <li role="menuitem">
          <a class="dropdown-item" (click)="openAddClientModal()"
            >Invite a New User</a
          >
        </li>
        <li role="menuitem">
          <a class="dropdown-item" (click)="openAddClientExistingUsersModal()"
            >From Existing Workspace</a
          >
        </li>
      </ul>
    </div>
  }
  @if (showUsers) {
    <div class="people-section__users-and-contacts">
      @if (current_company?.invites?.length > 0) {
        <div class="people-section__users-and-contacts-users">
          <h2>Invites</h2>
          @for (invite of current_company.invites; track invite) {
            <div
              style="width: calc(100vw - 710px); margin-top: 10px"
              (click)="openSideModal = true"
              class="people-section__staff-accountant"
            >
              <div class="info">
                <img
                  src="https://s3.amazonaws.com/ch-90afd80709-pb/avatar_default_22D56.png"
                  class="avatar"
                  style="width: 40px; height: 40px"
                />
                <div class="name-and-email">
                  <p>{{ invite.name }}</p>
                  <span>{{ invite.email }}</span>
                </div>
              </div>
              <div
                style="
                  display: flex;
                  gap: 20px;
                  margin-left: auto;
                  align-items: center;
                "
              >
                <a
                  (click)="viewInviteLink(invite)"
                  style="font-family: Figtree, sans-serif; font-size: 16px"
                  >Copy Invite Link</a
                >
                <a
                  (click)="sendInviteEmail(invite.id)"
                  style="font-family: Figtree, sans-serif; font-size: 16px"
                  >Re-send Invite</a
                >
                <button
                  (click)="removeInvite(invite.id)"
                  class="btn btn-danger"
                  style="font-size: 14px"
                >
                  Remove
                </button>
              </div>
            </div>
          }
        </div>
      }
      <div class="people-section__users-and-contacts-users">
        <h2 class="mb-4">Users</h2>
        @if (current_company.users?.length === 0) {
          <div class="empty-dashboard-row-content">
            <ds-empty-state
              icon="tio-briefcase"
              title="No Clients to Display"
              description="Start by adding clients or check back later to see updates."
            ></ds-empty-state>
          </div>
        }
        @for (data of current_company.users; track data) {
          <div
            class="people-section__users-and-contacts-users--user-or-contact"
            (click)="openDrawer(data)"
          >
            <header class="header">
              <div class="user">
                <img
                  class="avatar"
                  style="width: 40px; height: 40px"
                  [src]="data.user.pictureUrl"
                  alt=""
                />
                <div class="name-and-email">
                  <p>{{ data.user.full_name }}</p>
                  <span>{{ data.user.email }}</span>
                </div>
              </div>
              <div class="status-and-2fa">
                <span>Status</span>
                <p>
                  <i class="feather check" style="color: rgb(28, 211, 28)"></i>
                  Joined
                </p>
              </div>
              <div class="status-and-2fa">
                <span>2FA Enabled?</span>
                <p>{{ data.is_2fa_enabled ? "Enabled" : "Disabled" }}</p>
              </div>
              <!-- <div
                      class="actions"
                      dropdown
                      dropdownToggle
                      (click)="openDropdownWithoutTriggeringParentClick($event)"
                      >
                      <i class="feather more-horizontal"></i>
                      <ul
                        id="dropdown-basic"
                        *dropdownMenu
                        class="dropdown-menu dropdown-menu-right"
                        role="menu"
                        aria-labelledby="button-basic"
                        >
                        <li role="menuitem">
                          <a (click)="removeClientUser(data.user)" class="dropdown-item"
                            >Remove</a
                            >
                          </li>
                        </ul>
                      </div> -->
            </header>
            <hr style="height: 1px; color: #d7dbe1; width: 100%" />
            <main class="fields">
              <div class="fields-wrapper">
                @for (data_field of data?.data_field_values; track data_field) {
                  <div class="field">
                    <span>{{ data_field.field.name }}</span>
                    <p>
                      {{
                        data_field.field.type === "date"
                          ? (data_field.value | date)
                          : data_field.value
                      }}
                    </p>
                  </div>
                }
              </div>
              <div class="more-button">
                <p>More...</p>
              </div>
            </main>
          </div>
        }
      </div>
      @if (current_company?.contacts?.length > 0) {
        <div class="people-section__users-and-contacts-users">
          <h2 style="margin-bottom: 10px">Contacts</h2>
          @for (contact of current_company.contacts; track contact) {
            <div
              (click)="openDrawer(contact)"
              class="people-section__users-and-contacts-users--user-or-contact"
            >
              <header class="header">
                <div class="user">
                  <div class="name-and-email">
                    <p>{{ contact.name }}</p>
                    <span>{{
                      getContactEmailFromDataFieldValues(
                        contact.data_field_values
                      )
                    }}</span>
                  </div>
                </div>
                <div class="status-and-2fa">
                  <button
                    (click)="inviteContactToBecomeClient($event, contact)"
                    class="btn btn-primary invite-btn"
                  >
                    <i class="feather user-plus"></i>
                    Invite as user
                  </button>
                </div>
                <div
                  class="actions"
                  dropdown
                  dropdownToggle
                  (click)="openDropdownWithoutTriggeringParentClick($event)"
                >
                  <i class="feather more-horizontal"></i>
                  <ul
                    id="dropdown-basic"
                    *dropdownMenu
                    class="dropdown-menu dropdown-menu-right"
                    role="menu"
                    aria-labelledby="button-basic"
                  >
                    <li role="menuitem" (click)="deleteContact(contact.uuid)">
                      <a class="dropdown-item">Remove</a>
                    </li>
                  </ul>
                </div>
              </header>
              <hr style="height: 1px; color: #d7dbe1; width: 100%" />
              <main class="fields">
                <div class="fields-wrapper">
                  @for (
                    data_field of contact.data_field_values;
                    track data_field
                  ) {
                    <div class="field">
                      <span>{{ data_field.field.name }}</span>
                      <p>
                        {{
                          data_field.field.type === "date"
                            ? (data_field.value | date)
                            : data_field.value
                        }}
                      </p>
                    </div>
                  }
                  <div class="more-button">
                    <p>More...</p>
                  </div>
                </div>
              </main>
            </div>
          }
        </div>
      }
    </div>
  }
  @if (!showUsers) {
    <div class="people-section__staff">
      @if (!showUsers) {
        <button
          (click)="openAddStaffUserModal()"
          style="width: 152px; margin-bottom: 15px"
          id="button-basic"
          class="btn btn-primary"
        >
          Assign Staff User
        </button>
      }
      <h2 class="mb-4">Staff</h2>
      @if (current_company.accountants.length === 0) {
        <div class="empty-dashboard-row-content">
          <ds-empty-state
            icon="tio-group_equal"
            title="No Staff to Display"
            description="Start by adding staff or check back later to see updates."
          ></ds-empty-state>
        </div>
      }
      @for (data of current_company.accountants; track data) {
        <div
          (click)="openSideModal = true"
          class="people-section__staff-accountant"
        >
          <div class="info">
            <img
              class="avatar"
              style="width: 40px; height: 40px"
              [src]="data.user.pictureUrl"
            />
            <div class="name-and-email">
              <p>{{ data.user.full_name }}</p>
              <span>{{ data.user.email }}</span>
            </div>
          </div>
          <button
            (click)="unassignAccountantFromClient(data.user.id)"
            class="btn btn-danger"
            style="font-size: 1rem; margin-left: auto"
          >
            Unassign
          </button>
        </div>
      }
    </div>
  }
</div>

<app-drawer
  [isForClientDetails]="false"
  [isForContact]="isForContact"
  [userOrContactDrawer]="userOrContactDrawer"
  [ngClass]="{ open: drawerOpen }"
  (onHide)="changeHide($event)"
  (inviteContactToBecomeClientEvent)="inviteContactToBecomeClient(null, $event)"
  (removeClientUserEvent)="removeClientUser($event)"
  (removeContactEvent)="deleteContact($event)"
></app-drawer>
